/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Ask_Conversation_Tips_BodyInputs */



/**
* | output |
* | --- |
* | "Not sure how to approach this conversation? Ask for conversation tips before you start." |
*
* @param {Nudge_Ask_Conversation_Tips_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_ask_conversation_tips_body = /** @type {((inputs?: Nudge_Ask_Conversation_Tips_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Ask_Conversation_Tips_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niet zeker hoe je dit gesprek aanpakt? Vraag gesprekstips voor je begint.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous ne savez pas trop comment aborder cette conversation ? Demandez des conseils avant de commencer.")
	return /** @type {LocalizedString} */ ("Not sure how to approach this conversation? Ask for conversation tips before you start.")
});